module.exports = __webpack_public_path__ + "img/banco_industrial.fd3a08a.png";